export const assertUnreachable = (x: never): never => {
  throw new Error(`I cannot be here: ${x}`);
};
